export default (columnHead) => {
    switch (columnHead) {
        case 'DATE':
            return sortByColumnHead(columnHead, sortDateValueColumns);
        case 'AD_UNIT':
        case 'GEO':
        case 'DEVICE':
        case 'SITE':
            return sortByColumnHead(columnHead, sortTextValueColumns);
        case 'CPM':
        case 'REVENUE':
        case 'IMPRESSION':
        case 'VIDEO_CPM':
        case 'VIDEO_IMPRESSION':
        case 'VIDEO_REVENUE':
        case 'DISPLAY_CPM':
        case 'DISPLAY_IMPRESSION':
        case 'DISPLAY_REVENUE':
        default:
            return sortByColumnHead(columnHead, sortNumberValueColumns);

    }
}

const sortByColumnHead = (columnHead, sortFunc) => {
    return (data, currentSortedColumn) => {
        return sortFunc(data, columnHead, currentSortedColumn)
    }
};

//HELPER FUNCTIONS
const sortNumberValueColumns = (data, columnHead, ascending) => data.sort((rowA, rowB) => ascending ? rowB[columnHead] - rowA[columnHead] : rowA[columnHead] - rowB[columnHead]);

const sortDateValueColumns = (data, columnHead, ascending) => data.sort((rowA, rowB) => ascending ? new Date(rowB[columnHead]).getTime() - new Date(rowA[columnHead]).getTime() : new Date(rowA[columnHead]).getTime() - new Date(rowB[columnHead]).getTime());

const sortTextValueColumns = (data, columnHead, ascending) => data.sort((rowA, rowB) => sortTextHelper(rowA[columnHead], rowB[columnHead], ascending));
//used to both sort and group strings in array
const sortTextHelper = (rowA, rowB, ascending) => {
    rowA = rowA.toLowerCase();
    rowB = rowB.toLowerCase();
    return ascending ? (rowB > rowA ? -1 : rowA > rowB ? 1 : 0) : (rowA > rowB ? -1 : rowB > rowA ? 1 : 0);
};